/* Clingy filmstrip — adds a branded header, live counter and progress bar to
   the product gallery thumbnails, and keeps working when the gallery is
   swapped out on a color change. */
(function () {
  if (window.__clingyFilmstrip) return;
  window.__clingyFilmstrip = true;

  var HAND_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4 12h14M13 6l6 6-6 6"/></svg>';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function swapText(holder, text) {
    var old = holder.querySelector('span');
    if (old && old.textContent === text) return;
    var next = document.createElement('span');
    next.className = 'is-entering';
    next.innerHTML = text;
    if (old) {
      old.classList.add('is-leaving');
      setTimeout(function () { old.remove(); }, 350);
      next.style.position = 'absolute';
      next.style.inset = '0';
    }
    holder.appendChild(next);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        next.classList.remove('is-entering');
        setTimeout(function () { next.style.position = ''; next.style.inset = ''; }, 360);
      });
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(gallery) {
    if (!gallery || gallery.dataset.cfReady) return;
    var controls = gallery.querySelector('slideshow-controls[thumbnails]');
    if (!controls) return;
    var thumbs = Array.prototype.slice.call(controls.querySelectorAll('.slideshow-controls__thumbnail'));
    if (thumbs.length < 2) return;
    gallery.dataset.cfReady = '1';

    var total = thumbs.length;
    var colorName = gallery.dataset.colorName || '';
    var hintText = gallery.dataset.swipeText || 'Swipe to explore';

    thumbs.forEach(function (t, i) { t.style.setProperty('--cf-i', i); });

    /* header */
    var head = document.createElement('div');
    head.className = 'cf-head';
    head.innerHTML =
      '<span class="cf-count" aria-hidden="true"><b>01</b> / ' + pad(total) + '</span>';
    controls.insertBefore(head, controls.firstChild);
    var countEl = head.querySelector('.cf-count b');

    /* progress */
    var progress = document.createElement('div');
    progress.className = 'cf-progress';
    progress.innerHTML = '<span class="cf-progress__fill"></span>';
    controls.appendChild(progress);

    var container = controls.querySelector('.slideshow-controls__thumbnails-container');
    var interacted = false;

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    /* ClingyHooks mobile: dot pagination that mirrors the (hidden) thumbnails */
    var dotEls = [];
    if (gallery.hasAttribute('data-cf-dots')) {
      var dots = document.createElement('div');
      dots.className = 'cf-dots';
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Product media');
      thumbs.forEach(function (t, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cf-dot';
        d.setAttribute('role', 'tab');
        /* a video thumbnail carries a badge — mirror that on its dot */
        if (t.querySelector('.slideshow-controls__thumbnail-badge, [class*="badge"], svg path[d*="M8 5v14"]')) {
          d.classList.add('cf-dot--video');
          d.setAttribute('aria-label', 'Show the product video');
        } else {
          d.setAttribute('aria-label', 'Show media ' + (i + 1) + ' of ' + total);
        }
        d.addEventListener('click', function () { t.click(); });
        dots.appendChild(d);
        dotEls.push(d);
      });
      gallery.appendChild(dots);
    }

    /* ── video slides: make it obvious there's something to watch ──
       Autoplayed video is muted (phones require it), so we add a small
       Watch / Tap for sound cue over the slide instead of leaving it silent
       and unmarked. */
    (function videoCues(){
      var slides = gallery.querySelectorAll('slideshow-slide, .slideshow-slide, [class*="slideshow-slide"]');
      slides.forEach(function (slide) {
        var media = slide.querySelector('video, deferred-media');
        if (!media || slide.querySelector('.cf-videocue')) return;
        var cue = document.createElement('button');
        cue.type = 'button';
        cue.className = 'cf-videocue';
        cue.innerHTML = '<span class="cf-videocue__ic" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' +
          '<span class="cf-videocue__t">Watch</span>';
        cue.setAttribute('aria-label', 'Play the product video with sound');
        slide.appendChild(cue);

        cue.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var v = slide.querySelector('video');
          if (!v) {
            /* not yet revealed: let the theme's own play button do its job */
            var poster = slide.querySelector('.deferred-media__poster-button');
            if (poster) poster.click();
            return;
          }
          v.muted = !v.muted;
          if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); }
          cue.classList.toggle('is-on', !v.muted);
          cue.querySelector('.cf-videocue__t').textContent = v.muted ? 'Watch' : 'Sound on';
        });
      });
    })();

    var lastIndex = -1;
    function update(fromUser) {
      var i = current();
      if (i === lastIndex) return;          /* ignore repeat notifications while swiping */
      lastIndex = i;
      countEl.textContent = pad(i + 1);
      dotEls.forEach(function (d, n) { d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      progress.style.setProperty('--cf-progress', ((i + 1) / total) * 100 + '%');
      /* the theme itself keeps the active thumbnail centred — no extra scrolling here */

    }

    update(false);

    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(true); });
    });
    thumbs.forEach(function (t) {
      mo.observe(t, { attributes: true, attributeFilter: ['aria-selected'] });
    });

  }

  function scan() {
    var galleries = document.querySelectorAll('media-gallery[data-clingy-filmstrip]');
    for (var i = 0; i < galleries.length; i++) init(galleries[i]);
  }

  function boot() {
    scan();
    /* the gallery is replaced (not edited) when a color is picked — watch for that */
    var pending = false;
    new MutationObserver(function (records) {
      var relevant = false;
      for (var r = 0; r < records.length && !relevant; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType === 1 && (node.matches('media-gallery') || node.querySelector('media-gallery'))) { relevant = true; break; }
        }
      }
      if (!relevant || pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
